module.exports = __webpack_public_path__ + "img/instagram.05b38ff2.svg";